import api from "./api";

class AllinpayService {
    cnpSale(dataForm) {
        return api.post('/allinpay/cnp-sale', dataForm);
    }

    cardSale(dataForm) {
        return api.post("/allinpay/card-sale", dataForm);
    }

    cardQuery(dataForm) {
        return api.post("/allinpay/card-query", dataForm);
    }

    cancelCardSale(dataForm) {
        return api.post("/allinpay/cancel-card-sale", dataForm);
    }

    getQRCode(dataForm) {
        return api.post("/allinpay/get-qr-code", dataForm);
    }

    qrCodeQuery(dataForm) {
        return api.post("/allinpay/qr-code-query", dataForm);
    }
}

export default new AllinpayService();